// extracted by mini-css-extract-plugin
export default {"modalContainer":"CoverModal_modalContainer__UKP2Y","modalCover":"CoverModal_modalCover__U+gL3","clickableCover":"CoverModal_clickableCover__FQLFZ"};